// extracted by mini-css-extract-plugin
export default {"title":"PageTitle_title__biwpv","eyebrow":"PageTitle_eyebrow__US1sA","h2":"PageTitle_h2__36Cv6"};